import api from './api';

const minorMemberService = {
  getAll: async (params = {}) => {
    const response = await api.get('/api/v1/minor-members', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/api/v1/minor-members/${id}`);
    return response.data;
  },

  getByWorshipId: async (worshipId) => {
    const response = await api.get(`/api/v1/minor-members/by-worship-id/${worshipId}`);
    return response.data;
  },

  getNextWorshipId: async (memberType = 'children') => {
    const response = await api.get('/api/v1/minor-members/next-worship-id', {
      params: { member_type: memberType }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/api/v1/minor-members', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/api/v1/minor-members/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    await api.delete(`/api/v1/minor-members/${id}`);
    return { success: true };
  },

  searchMembers: async (search = '', limit = 10) => {
    try {
      const response = await api.get('/api/v1/minor-members', {
        params: { search, limit, skip: 0 }
      });
      return response.data?.data || [];
    } catch (error) {
      console.error('Error searching minor members:', error);
      return [];
    }
  },
};

export default minorMemberService;
